import { gql } from '@apollo/client';

export const getSpecialityGroups = gql`
  query getSpecialityGroups {
    specialityGroups(filter: { state: { _eq: ACTIVE } }) {
      totalCount
      edges {
        node {
          id
          oid
          name
        }
      }
    }
  }
`;
